import { useState, useEffect } from "react";
import "../css/header.css";
import hlogo from "../assets/eVridya-Logo-2H.png";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronRight, BookOpen, Users, Calendar } from "lucide-react";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [dropdown, setDropdown] = useState(null); 
  const [subDropdown, setSubDropdown] = useState(null); 
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigation = (label, parentLabel = null) => {
    setMenuOpen(false);
    setDropdown(null);
    setSubDropdown(null);
    
    const dynamicPath = label.toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-');

    if (parentLabel === "Study Abroad") {
      navigate(`/study-abroad/${dynamicPath}`);
    } else if (parentLabel === "Services") {
      navigate(`/services/${dynamicPath}`);
    } else {
      const routes = {
        "Home": "/",
        "About Us": "/about",
        "Courses": "/courses",
        "Blog": "/blog",
        "Contact": "/register",
        "Universities": "/ourpartners",
        "Register Now": "/register"
      };
      if (routes[label]) navigate(routes[label]);
    }
    window.scrollTo(0, 0);
  };

  const handleLogout = () => {
    setMenuOpen(false);
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const toggleDropdown = (label) => {
    setDropdown(dropdown === label ? null : label);
    setSubDropdown(null);
  };

  const navLinks = [
    { label: "Home" },
    { label: "Study Abroad", children: ["Australia", "Canada", "France", "Germany", "Ireland", "Japan", "Moldova", "NewZealand", "Netherlands", "Singapore", "UK", "USA", "UAE"] },
    { label: "About Us" },
    {
      label: "Services",
      isMultiLevel: true,
      categories: [
        { name: "Counselling & Partnership", icon: <BookOpen size={16} />, items: ["Career Counselling", "Student Counselling", "Study Abroad Guidance", "University Partnerships", "School Partnerships", "NIFT NID UCEED Coaching"] },
        { name: "School Support", icon: <Users size={16} />, items: ["Teacher Recruitment", "IT Support Services", "Interactive Panels"] },
        { name: "Events & Seminars", icon: <Calendar size={16} />, items: ["Career Fairs", "Workshops Seminars", "Education Events"] }
      ]
    },
    { label: "Courses" },
    { label: "Universities" },
    { label: "Blog" },
    { label: "Contact" },
  ];

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        <div className="hlogo" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
          <img src={hlogo} alt="logo" />
        </div>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          {navLinks.map((link) => (
            <li key={link.label} className={dropdown === link.label ? "active" : ""}>
              <div className="nav-item-header" onClick={() => (link.children || link.isMultiLevel) ? toggleDropdown(link.label) : handleNavigation(link.label)}>
                {link.label}
                {(link.children || link.isMultiLevel) && <ChevronDown size={14} className="arrow" />}
              </div>
              
              {link.children && dropdown === link.label && (
                <div className="dropdown">
                  {link.children.map((item) => <p key={item} onClick={() => handleNavigation(item, link.label)}>{item}</p>)}
                </div>
              )}
              {link.isMultiLevel && dropdown === link.label && (
                <div className="mega-dropdown">
                  <div className="side-menu">
                    {link.categories.map((cat) => (
                      <div key={cat.name} className={`side-item ${subDropdown === cat.name ? "active-sub" : ""}`} onClick={(e) => { e.stopPropagation(); setSubDropdown(subDropdown === cat.name ? null : cat.name); }}>
                        <span className="cat-link">{cat.icon} {cat.name}</span>
                        <ChevronRight size={14} />
                      </div>
                    ))}
                  </div>
                  {subDropdown && (
                    <div className="content-menu">
                      {link.categories.find(c => c.name === subDropdown)?.items.map((item) => <p key={item} onClick={() => handleNavigation(item, "Services")}>{item}</p>)}
                    </div>
                  )}
                </div>
              )}
            </li>
          ))}

          {/* MOBILE ONLY ACTIONS: Yeh hamburger menu ke andar dekhega */}
          <li className="mobile-nav-actions">
            {token ? (
              <button className="btn logout-btn mobile-btn" onClick={handleLogout}>Logout ↩</button>
            ) : (
              <div className="mobile-buttons-wrapper">
                <button 
                  className="btn login-btn mobile-btn" 
                  onClick={() => { setMenuOpen(false); navigate("/register?mode=login"); }}
                >
                  Login
                </button>
                <button 
                  className="btn register-btn mobile-btn" 
                  onClick={() => { setMenuOpen(false); navigate("/register?mode=register"); }}
                >
                  Register Now
                </button>
              </div>
            )}
          </li>
        </ul>

        {/* DESKTOP ACTIONS */}
        <div className="nav-actions">
          <div className="desktop-buttons">
            {token ? (
              <button className="btn logout-btn" onClick={handleLogout}>Logout ↩</button>
            ) : (
              <>
                <button 
                  className="btn login-btn" 
                  onClick={() => navigate("/register?mode=login")}
                >
                  Login
                </button>
                <button 
                  className="btn register-btn" 
                  onClick={() => navigate("/register?mode=register")}
                >
                  Register Now
                </button>
              </>
            )}
          </div>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? "✕" : "☰"} {/* Open hone par cross (✕) dikhega */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;